<template>
  <div class="setting-price one-component-detail-admin">
    <div class="title-component-admin">Giá</div>
    <div v-if="data && data.price_info" class="mx-3">
      <el-row type="flex" class="py-3">
        <el-radio
          v-model="data.price_info.free"
          :label="true"
        >Miễn phí</el-radio>
        <el-radio
          v-model="data.price_info.free"
          :label="false"
        >Khoảng giá</el-radio>
      </el-row>
      <el-form
        v-if="!data.price_info.free"
        :model="data.price_info"
        inline
        label-position="left"
      >
        <el-row type="flex">
          <el-form-item label="Từ">
            <el-input
              :value="formatPrice(data.price_info.minimum)"
              placeholder="0"
              @input="(val) => handleInputPrice(val, 'minimum')"
              @blur="handleBlurPrice('minimum')"
            >
              <template slot="append">VNĐ</template>
            </el-input>
          </el-form-item>
          <el-form-item label="Đến" class="ml-3">
            <el-input
              :value="formatPrice(data.price_info.maximum)"
              placeholder="0"
              @input="(val) => handleInputPrice(val, 'maximum')"
              @blur="handleBlurPrice('maximum')"
            >
              <template slot="append">VNĐ</template>
            </el-input>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Price',
  props: {
    data: Object
  },
  methods: {
    formatPrice(val) {
      if (val === null || val === undefined || val === '') return ''
      const str = val.toString().replace(/\D/g, '')
      if (!str) return ''
      return str.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    handleInputPrice(val, field) {
      const clean = (val || '').toString().replace(/\D/g, '')
      const num = clean !== '' ? parseInt(clean, 10) : ''
      this.$set(this.data.price_info, field, num)
    },
    handleBlurPrice(field) {
      if (this.data && this.data.price_info) {
        if (
          this.data.price_info[field] === '' ||
          this.data.price_info[field] === null ||
          this.data.price_info[field] === undefined
        ) {
          this.$set(this.data.price_info, field, 0)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
